import { FC } from 'react';

import {
  Training,
  Catalog,
  Settings,
  GeneratedDocs,
  Home,
  Logout,
  ProjectSettings,
  NavigateBackIcon,
  NavigateNextIcon,
  ZoomInIcon,
  CheckMarkIcon,
  UnlockIcon,
  LockIcon,
  ZoomOutIcon,
} from '../../assets/icons/sidebar';
import { ArchiveIcon, DeleteIcon, EditIcon } from '../../assets/icons/actions';
import { BackArrowIcon } from '../../assets/icons';

export type IconType =
  | 'cross'
  | 'delete'
  | 'delete-light'
  | 'delete-light-border'
  | 'edit'
  | 'edit-light'
  | 'moderna-logo-small'
  | 'moderna-logo'
  | 'mapping'
  | 'catalog'
  | 'gear'
  | 'arrow_down'
  | 'arrow_up'
  | 'pen'
  | 'json-export'
  | 'generatedDocs'
  | 'power'
  | 'change-password'
  | 'camera'
  | 'fileUpload'
  | 'multiFileUpload'
  | 'templateTraining2'
  | 'templateTraining'
  | 'unlock'
  | 'lock'
  | 'manage-permissions'
  | 'down-arrow'
  | 'previewDocument'
  | 'avatar-placeholder'
  | 'home'
  | 'logout'
  | 'project-settings'
  | 'filter-icon'
  | 'arrow-up'
  | 'arrow-down'
  | 'arrow-left'
  | 'arrow-right'
  | 'chevron-down'
  | 'button-dots'
  | 'close'
  | 'warning'
  | 'check-mark'
  | 'zoom-in'
  | 'zoom-out'
  | 'navigate-back'
  | 'navigate-next'
  | 'arrow-back'
  | 'archive'
  | 'add'
  | 'document'
  | 'user'
  | 'users'
  | 'calendar'
  | 'hashtag';

interface Props extends React.SVGProps<SVGSVGElement> {
  iconType: IconType;
  stroke?: string;
  size?: string;
  onClick?: React.MouseEventHandler<SVGElement>;
  className?: string;
}

//TODO add ENUM for iconType
const SvgIcon: FC<Props> = ({
  iconType,
  stroke,
  size,
  onClick = () => {},
  className = '',
  ...rest
}) => {
  switch (iconType) {
    case 'delete':
      return (
        <svg role="img" viewBox="0 0 24 24" width="22px" height="22px" fill="#EC2B00">
          <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"></path>
        </svg>
      );
    case 'hashtag':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="h-4 w-4">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M5.25 8.25h15m-16.5 7.5h15m-1.8-13.5-3.9 19.5m-2.1-19.5-3.9 19.5"
          />
        </svg>
      );
    case 'calendar':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="h-5 w-5">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"
          />
        </svg>
      );
    case 'users':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="h-5 w-5">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z"
          />
        </svg>
      );
    case 'user':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="h-5 w-5">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z"
          />
        </svg>
      );
    case 'document':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="h-5 w-5">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
          />
        </svg>
      );
    case 'delete-light':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="15"
          viewBox="0 0 14 15"
          fill="none">
          <path
            d="M5.25 11.6875C5.25 11.9336 5.03125 12.125 4.8125 12.125C4.56641 12.125 4.375 11.9336 4.375 11.6875V6C4.375 5.78125 4.56641 5.5625 4.8125 5.5625C5.03125 5.5625 5.25 5.78125 5.25 6V11.6875ZM7.4375 11.6875C7.4375 11.9336 7.21875 12.125 7 12.125C6.75391 12.125 6.5625 11.9336 6.5625 11.6875V6C6.5625 5.78125 6.75391 5.5625 7 5.5625C7.21875 5.5625 7.4375 5.78125 7.4375 6V11.6875ZM9.625 11.6875C9.625 11.9336 9.40625 12.125 9.1875 12.125C8.94141 12.125 8.75 11.9336 8.75 11.6875V6C8.75 5.78125 8.94141 5.5625 9.1875 5.5625C9.40625 5.5625 9.625 5.78125 9.625 6V11.6875ZM9.54297 1.43359L10.5547 2.9375H12.4688C12.8242 2.9375 13.125 3.23828 13.125 3.59375C13.125 3.97656 12.8242 4.25 12.4688 4.25H12.25V12.5625C12.25 13.793 11.2656 14.75 10.0625 14.75H3.9375C2.70703 14.75 1.75 13.793 1.75 12.5625V4.25H1.53125C1.14844 4.25 0.875 3.97656 0.875 3.59375C0.875 3.23828 1.14844 2.9375 1.53125 2.9375H3.41797L4.42969 1.43359C4.70312 1.02344 5.19531 0.75 5.71484 0.75H8.25781C8.77734 0.75 9.26953 1.02344 9.54297 1.43359ZM5.00391 2.9375H8.96875L8.44922 2.17188C8.42188 2.11719 8.33984 2.0625 8.25781 2.0625H5.71484C5.63281 2.0625 5.55078 2.11719 5.52344 2.17188L5.00391 2.9375ZM3.0625 12.5625C3.0625 13.0547 3.44531 13.4375 3.9375 13.4375H10.0625C10.5273 13.4375 10.9375 13.0547 10.9375 12.5625V4.25H3.0625V12.5625Z"
            fill="#EC2B00"
          />
        </svg>
      );
    case 'delete-light-border':
      return <DeleteIcon onClick={onClick} className={className} {...rest} />;
    case 'edit':
      return (
        <svg role="img" viewBox="0 0 24 24" width="22px" height="22px" fill="#0f766e">
          <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"></path>
        </svg>
      );
    case 'edit-light':
      return <EditIcon onClick={onClick} className={className} {...rest} />;
    case 'moderna-logo-small':
      return (
        <svg
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          width="42"
          height="34"
          viewBox="0 0 42 34"
          fill="none">
          <rect width="42" height="34" fill="url(#pattern0)" />
          <defs>
            <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
              <use
                xlinkHref="#image0_2338_2318"
                transform="matrix(0.00909091 0 0 0.0111111 -0.522727 -0.75)"
              />
            </pattern>
            <image
              id="image0_2338_2318"
              width="225"
              height="225"
              xlinkHref="data:image/png;base64,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"
            />
          </defs>
        </svg>
      );
    case 'moderna-logo':
      return (
        <svg
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          width="165"
          height="53"
          viewBox="-172.4 -2.4 600 95">
          <g strokeWidth="4.6" strokeLinecap="round">
            <path d="m1,80h19" stroke={stroke ? stroke : '#a6dff9'} />
            <path d="m31,80h19" stroke={stroke ? stroke : '#93daf8'} />
            <path d="m61,80h19" stroke={stroke ? stroke : '#7ed4f7'} />
            <path d="m91,80h19" stroke={stroke ? stroke : '#6bcff6'} />
            <path d="m121,80h19" stroke={stroke ? stroke : '#52cbf5'} />
            <path d="m151,80h19" stroke={stroke ? stroke : '#39c6f4'} />
            <path d="m181,80h19" stroke={stroke ? stroke : '#20c2f3'} />
            <path d="m211,80h19" stroke={stroke ? stroke : '#04bef2'} />
            <path d="m241,80h19" stroke={stroke ? stroke : '#00baf2'} />
            <path d="m271,80h19" stroke={stroke ? stroke : '#00b6f1'} />
            <path d="m301,80h19" stroke={stroke ? stroke : '#00b3f0'} />
            <path d="m331,80h19" stroke={stroke ? stroke : '#00afef'} />
          </g>
          <path
            d="M165.2 0v24.5a20 20 0 0 0-17-9c-6.2 0-11.4 2.2-15.8 6.6A22 22 0 0 0 126 38c0 6.4 2.2 11.7 6.5 16.1 4.2 4.5 9.5 6.7 15.5 6.7 3.5 0 6.7-.8 9.6-2.1 2.8-1.5 5.4-3.6 7.7-6.4v7.4h5.5V0Zm-145 15c-3 0-6 .8-8.8 2.5a21 21 0 0 0-5.9 6.1v-7.5H0v43.6h5.5V41.2c0-5.5.6-9.5 1.6-12.2a14 14 0 0 1 4.9-6.3c2.2-1.5 4.6-2.3 7.1-2.3 2.2 0 4.1.6 5.8 1.7a9.2 9.2 0 0 1 3.4 4.5c.6 2 .9 5.5.9 10.8v22.3h5.5v-17c0-6.3.5-10.8 1.5-13.5 1-2.6 2.7-4.8 4.9-6.4 2.2-1.6 4.6-2.4 7.3-2.4 2.2 0 4 .5 5.6 1.6 1.6 1 2.7 2.5 3.4 4.2.7 1.8 1 5 1 9.7v23.8H64V36c0-5.4-.5-9.6-1.6-12.3a13.5 13.5 0 0 0-13-8.7c-3.1 0-6 1-8.8 2.7-2.7 1.8-5 4.4-6.9 7.8-.8-2.5-1.9-4.5-3-5.9a12 12 0 0 0-4.6-3.3c-1.9-.9-3.8-1.3-6-1.3zm75.3 0c-6.5 0-11.9 2.4-16 7.3A23 23 0 0 0 73.5 38c0 6 2 11.4 6.2 16 4 4.5 9.3 6.8 15.7 6.8a20 20 0 0 0 15.7-6.9 23 23 0 0 0 6.1-15.9c0-6-1.9-11.3-5.8-15.8a20.5 20.5 0 0 0-16-7.3zM203 15c-7 0-12.6 2.7-16.9 8.2-3.3 4.3-4.9 9.2-4.9 14.8 0 5.9 2 11.1 5.9 15.8a20 20 0 0 0 16.2 7 21.5 21.5 0 0 0 15-5.8c2-1.8 3.8-4.3 5.2-7.3l-4.5-2.5c-1.7 2.9-3.2 5-4.7 6.2a17.6 17.6 0 0 1-11.5 4.2c-4.4 0-8.2-1.6-11.2-4.8-3.1-3.3-4.7-7.4-4.8-12.5h38.2c0-6-1.6-11-4.7-15A20.8 20.8 0 0 0 203 15zm46.8 0c-2.1 0-4.1.6-6 1.8a20 20 0 0 0-5.6 5.7V16h-5.8v43.6h5.8V45c0-7.6.4-12.7 1.1-15.1 1-3.3 2.3-5.7 4-7.2a8.2 8.2 0 0 1 5.6-2.3c.7 0 1.7.2 3 .8l3-4.8c-1.9-1-3.5-1.5-5.1-1.5zm33 0c-3.2 0-6.1.7-8.8 2.2a23 23 0 0 0-7.3 6.7V16h-5.5v43.6h5.5v-16c0-5.7.3-9.7.8-11.9.8-3.3 2.6-6 5.2-8.3 2.7-2.3 5.7-3.4 9-3.4 3 0 5.3.8 7 2.2a11 11 0 0 1 3.7 6.5c.5 1.7.7 5 .7 10.1v20.8h5.5V37.3c0-6-.6-10.4-1.8-13.2-1.2-2.8-3-5-5.5-6.7a15 15 0 0 0-8.5-2.5zm47 0c-5.9 0-11 2.2-15.2 6.6a22.6 22.6 0 0 0-6.4 16.1 23 23 0 0 0 6.3 16.3 20.6 20.6 0 0 0 32-1.9v7.6h5.4V16h-5.3v8a21 21 0 0 0-7.4-6.9A19 19 0 0 0 330 15zm-126.8 5.3c2.6 0 5 .6 7.2 1.7 2.4 1 4.2 2.5 5.6 4.3 1.3 1.8 2.4 4.1 3.2 7.1h-31.7c1.2-4 2.8-7 5-9 3-2.7 6.6-4 10.7-4zm127.3 0c4.7 0 8.6 1.7 11.9 5.1 3.1 3.4 4.7 7.6 4.7 12.7 0 3.3-.7 6.3-2 8.9a16.7 16.7 0 0 1-14.5 8.6c-3 0-5.8-.8-8.4-2.3a18.5 18.5 0 0 1-6.1-24.1 16.2 16.2 0 0 1 14.4-8.8zm-235 .2c4.5 0 8.4 1.7 11.6 5.1a18.6 18.6 0 0 1 2.7 21.3 15.8 15.8 0 0 1-14.2 8.6 15.8 15.8 0 0 1-14.2-8.6 18.6 18.6 0 0 1-2.2-8.8c0-4.9 1.6-9 4.8-12.5 3.2-3.4 7-5.1 11.6-5.1zm53.2.3a17 17 0 0 1 17 17.5 18 18 0 0 1-2.2 8.9 17.7 17.7 0 0 1-14.9 8.5 17 17 0 0 1-14.7-8.8 17.8 17.8 0 0 1 0-17.4 16.7 16.7 0 0 1 14.8-8.7zM360 19.5h.8c.4 0 .7 0 .8-.2.2 0 .3-.2.3-.4l-.2-.3c0-.2 0-.2-.2-.3H360zm-.6 2.3v-4h2.4c.3.1.5.3.6.5l.2.5c0 .4-.2.6-.3.8a2 2 0 0 1-1 .4l.4.2.6.8.5.8h-.8l-.3-.7-.7-1h-.9v1.7zm1.6-5.3c-.5 0-1 .1-1.5.5-.5.2-.9.6-1.1 1.1a3 3 0 0 0 0 3.2c.2.5.6.9 1.1 1.1.5.4 1 .5 1.5.5.6 0 1.1-.1 1.6-.5.5-.2 1-.6 1.2-1.1.2-.5.4-1 .4-1.6 0-.5-.2-1-.4-1.6a3 3 0 0 0-1.2-1.1c-.5-.4-1-.5-1.6-.5zm0-.5c.7 0 1.3.1 1.9.4.6.3 1 .8 1.4 1.4.4.6.5 1.2.5 2 0 .6-.1 1.2-.5 1.8-.3.6-.8 1-1.4 1.4a4 4 0 0 1-1.9.5c-.6 0-1.2-.2-1.8-.5-.6-.3-1-.8-1.4-1.4-.3-.6-.5-1.2-.5-1.9s.2-1.3.5-1.9c.4-.6.8-1 1.4-1.4.6-.3 1.3-.4 1.8-.4z"
            fill="#e51937"
          />
        </svg>
      );
    case 'mapping':
      return (
        <svg
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          version="1.0"
          width="24.000000pt"
          height="24.000000pt"
          viewBox="0 0 48.000000 50.000000"
          preserveAspectRatio="xMidYMid meet">
          <g
            transform="translate(0.000000,50.000000) scale(0.100000,-0.100000)"
            fill={stroke ? stroke : '#2AACE2'}
            stroke={stroke ? stroke : '#2AACE2'}>
            <path
              d="M370 440 c-17 -34 -18 -40 -5 -40 36 0 -7 -80 -54 -101 -35 -16 -41 -39 -11 -39 30 0 88 58 101 101 7 21 18 39 26 39 7 0 13 2 13 4 0 7 -42 76 -46 76 -2 0 -13 -18 -24 -40z"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M40 425 c-28 -33 18 -77 59 -56 32 18 51 13 86 -22 22 -22 36 -47 40 -73 3 -21 8 -50 11 -63 7 -33 74 -98 110 -107 16 -4 37 -14 47 -22 20 -18 42 -10 61 21 8 13 6 22 -11 38 -20 21 -22 21 -50 4 -28 -16 -32 -16 -62 -1 -40 21 -67 64 -75 122 -3 24 -13 58 -21 75 -17 31 -69 69 -96 69 -9 0 -22 7 -29 15 -16 19 -54 19 -70 0z"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M144 236 c-20 -20 -38 -52 -46 -80 -7 -25 -18 -46 -25 -46 -8 0 -6 -11 8 -35 12 -19 24 -35 27 -35 4 0 15 14 25 31 15 27 16 33 3 43 -22 17 -8 63 30 102 19 18 34 38 34 44 0 19 -22 10 -56 -24z"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </svg>
      );
    case 'add':
      return (
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7.75 1.25V6.25H12.75H13.5V7.75H12.75H7.75V12.75V13.5H6.25V12.75V7.75H1.25H0.5V6.25H1.25H6.25V1.25V0.5H7.75V1.25Z"
            fill="#2AACE2"
          />
        </svg>
      );

    case 'catalog':
      return <Catalog stroke={stroke} fill={stroke} />;
    case 'gear':
      return <Settings stroke={stroke} fill={stroke} />;
    case 'arrow_down':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="w-6 h-6">
          <path
            fill="#CCCCCC"
            d="M7.293 8.293l-1.414 1.414L12 15.414l6.121-6.121-1.414-1.414L12 12.586 7.293 8.293z"
          />
        </svg>
      );
    case 'arrow_up':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="w-6 h-6">
          <path
            fill="#CCCCCC"
            d="M7.293 15.707l-1.414-1.414L12 8.586l6.121 6.121-1.414 1.414L12 11.414 7.293 15.707z"
          />
        </svg>
      );
    case 'pen':
      return (
        <svg
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none">
          <path
            d="M12 19L19 12L22 15L15 22L12 19Z"
            stroke={stroke ? stroke : '#2AACE2'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M18 13L16.5 5.5L2 2L5.5 16.5L13 18L18 13Z"
            stroke={stroke ? stroke : '#2AACE2'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M2 2L9.58579 9.58579" stroke={stroke ? stroke : '#2AACE2'} strokeWidth="2" />
          <circle cx="11" cy="11" r="2" stroke={stroke ? stroke : '#2AACE2'} strokeWidth="2" />
        </svg>
      );
    case 'json-export':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none">
          <rect
            x="9"
            y="15"
            width="6"
            height="6"
            rx="2"
            transform="rotate(90 9 15)"
            stroke={stroke ? stroke : '#2AACE2'}
            strokeWidth="2"
          />
          <path d="M18 3L21 7L18 11" stroke={stroke ? stroke : '#2AACE2'} strokeWidth="2" />
          <path
            d="M21 7H14C10.2288 7 8.34315 7 7.17157 8.17157C6 9.34315 6 11.2288 6 15V15"
            stroke={stroke ? stroke : '#2AACE2'}
            strokeWidth="2"
          />
        </svg>
      );
    case 'generatedDocs':
      return <GeneratedDocs stroke={stroke} fill={stroke} />;
    case 'power':
      return (
        <svg
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="10"
          viewBox="0 0 10 10"
          fill="none">
          <g clipPath="url(#clip0_914_803)">
            <path
              d="M7.65001 2.76666C8.17433 3.29116 8.53137 3.95935 8.67596 4.68674C8.82056 5.41414 8.74622 6.16808 8.46236 6.85323C8.17849 7.53838 7.69785 8.12398 7.08119 8.53598C6.46453 8.94798 5.73955 9.16788 4.99793 9.16788C4.2563 9.16788 3.53132 8.94798 2.91467 8.53598C2.29801 8.12398 1.81736 7.53838 1.5335 6.85323C1.24963 6.16808 1.1753 5.41414 1.31989 4.68674C1.46449 3.95935 1.82152 3.29116 2.34584 2.76666"
              stroke="#303D53"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5 0.833313V4.99998"
              stroke="#303D53"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_914_803">
              <rect width="10" height="10" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'change-password':
      return (
        <svg
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="10"
          viewBox="0 0 10 10"
          fill="none">
          <g clipPath="url(#clip0_914_797)">
            <path
              d="M5.83333 0.833313L7.5 2.49998L2.91667 7.08331H1.25V5.41665L5.83333 0.833313Z"
              stroke="#303D53"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M1.25 9.16669H8.75"
              stroke="#303D53"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_914_797">
              <rect width="10" height="10" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'camera':
      return (
        <svg
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="10"
          viewBox="0 0 10 10"
          fill="none">
          <g clipPath="url(#clip0_914_796)">
            <path
              d="M9.58329 7.91667C9.58329 8.13768 9.49549 8.34964 9.33921 8.50592C9.18293 8.6622 8.97097 8.75 8.74996 8.75H1.24996C1.02895 8.75 0.816984 8.6622 0.660704 8.50592C0.504423 8.34964 0.416626 8.13768 0.416626 7.91667V3.33333C0.416626 3.11232 0.504423 2.90036 0.660704 2.74408C0.816984 2.5878 1.02895 2.5 1.24996 2.5H2.91663L3.74996 1.25H6.24996L7.08329 2.5H8.74996C8.97097 2.5 9.18293 2.5878 9.33921 2.74408C9.49549 2.90036 9.58329 3.11232 9.58329 3.33333V7.91667Z"
              stroke="#303D53"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5.00004 7.08333C5.92052 7.08333 6.66671 6.33714 6.66671 5.41667C6.66671 4.49619 5.92052 3.75 5.00004 3.75C4.07957 3.75 3.33337 4.49619 3.33337 5.41667C3.33337 6.33714 4.07957 7.08333 5.00004 7.08333Z"
              stroke="#303D53"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_914_796">
              <rect width="10" height="10" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'fileUpload':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          data-name="Layer 1"
          id="Layer_1"
          width="25"
          height="38"
          viewBox="0 0 55 55">
          <defs></defs>
          <title />
          <path d="M11,62H53a3,3,0,0,0,3-3V17s0,0,0-.06a1.09,1.09,0,0,0-.05-.26.36.36,0,0,0,0-.09,1.17,1.17,0,0,0-.19-.3l-14-14a1.17,1.17,0,0,0-.3-.19l-.09,0L41.07,2H11A3,3,0,0,0,8,5V59A3,3,0,0,0,11,62Zm43-3a1,1,0,0,1-1,1H11a1,1,0,0,1-1-1V54H54ZM52.59,16H43a1,1,0,0,1-1-1V5.41ZM11,4H40V15a3,3,0,0,0,3,3H54V52H10V5A1,1,0,0,1,11,4Z" />
          <path d="M24.94,43.5H38.45A5.41,5.41,0,0,0,39,32.69a6.51,6.51,0,0,0-6-5.15v-4l3.38,2.7a1,1,0,0,0,.62.22,1,1,0,0,0,.78-.38,1,1,0,0,0-.16-1.4l-5-4a.64.64,0,0,0-.14-.08l-.12-.07A1.09,1.09,0,0,0,32,20.5h0a1,1,0,0,0-.35.07l-.12.07a.39.39,0,0,0-.14.08l-5,4a1,1,0,0,0,1.24,1.56L31,23.58v4.11a6.5,6.5,0,0,0-5.06,6.25,5.47,5.47,0,0,0-1-.1,4.83,4.83,0,1,0,0,9.66Zm0-7.66a2.93,2.93,0,0,1,1.68.52,1,1,0,0,0,1.52-1.12,4.39,4.39,0,0,1-.2-1.29A4.45,4.45,0,0,1,31,29.78V35.5a1,1,0,0,0,2,0v-6a4.47,4.47,0,0,1,4.13,4.17,1,1,0,0,0,.34.71,1,1,0,0,0,.75.24h.17a3.42,3.42,0,1,1,.06,6.84H24.94a2.83,2.83,0,1,1,0-5.66Z" />
        </svg>
      );
    case 'multiFileUpload':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          data-name="Layer 1"
          id="Layer_1"
          width="25"
          height="38"
          viewBox="0 0 55 55">
          <defs></defs>
          <title />
          <path d="M55.94,16.68a.36.36,0,0,0,0-.09,1.17,1.17,0,0,0-.19-.3l-14-14a1.17,1.17,0,0,0-.3-.19l-.09,0A1.09,1.09,0,0,0,41.06,2H15a3,3,0,0,0-3,3V6H11A3,3,0,0,0,8,9V59a3,3,0,0,0,3,3H49a3,3,0,0,0,3-3V58h1a3,3,0,0,0,3-3V17s0,0,0-.06A2,2,0,0,0,55.94,16.68ZM52.59,16H43a1,1,0,0,1-1-1V5.41ZM14,5a1,1,0,0,1,1-1H40V15a3,3,0,0,0,3,3H54V48H14ZM11,8h1V52H10V9A1,1,0,0,1,11,8ZM50,59a1,1,0,0,1-1,1H11a1,1,0,0,1-1-1V54h2v1a3,3,0,0,0,3,3H50Zm4-4a1,1,0,0,1-1,1H15a1,1,0,0,1-1-1V50H54Z" />
          <path d="M26.94,42H40.45A5.42,5.42,0,0,0,41,31.18,6.51,6.51,0,0,0,35,26v-4l3.38,2.7A1,1,0,0,0,39,25a1,1,0,0,0,.78-.38,1,1,0,0,0-.16-1.4l-5-4a.39.39,0,0,0-.14-.08l-.12-.07A1,1,0,0,0,34,19h0a1,1,0,0,0-.35.07l-.12.07a.39.39,0,0,0-.14.08l-5,4a1,1,0,0,0,1.24,1.56L33,22.08v4.11a6.5,6.5,0,0,0-5.06,6.25,5.47,5.47,0,0,0-1-.1,4.83,4.83,0,1,0,0,9.66Zm0-7.66a2.93,2.93,0,0,1,1.68.52,1,1,0,0,0,1.52-1.12,4.39,4.39,0,0,1-.2-1.29A4.44,4.44,0,0,1,33,28.28V34a1,1,0,0,0,2,0V28a4.47,4.47,0,0,1,4.13,4.17,1,1,0,0,0,.34.71,1,1,0,0,0,.75.24h.17A3.53,3.53,0,0,1,44,36.58,3.49,3.49,0,0,1,40.45,40H26.94a2.83,2.83,0,1,1,0-5.66Z" />
        </svg>
      );
    case 'templateTraining2':
      return <Training stroke={stroke} fill={stroke} />;
    case 'templateTraining':
      return <Training stroke={stroke} fill={stroke} />;
    case 'unlock':
      return <UnlockIcon />;
    case 'lock':
      return <LockIcon />;
    case 'manage-permissions':
      return null;
    case 'down-arrow':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="#ffffff">
          <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
        </svg>
      );
    case 'previewDocument':
      return (
        <svg width="14" height="15" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M22 24h-20v-24h14l6 6v18zm-7-23h-12v22h18v-16h-6v-6zm3 15v1h-12v-1h12zm0-3v1h-12v-1h12zm0-3v1h-12v-1h12zm-2-4h4.586l-4.586-4.586v4.586z"
            stroke="#2AACE2"
          />
        </svg>
      );
    case 'avatar-placeholder':
      return (
        <svg width={size} height={size} viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg">
          <path
            fill="currentColor"
            fillRule="evenodd"
            d="M.877 7.5a6.623 6.623 0 1 1 13.246 0a6.623 6.623 0 0 1-13.246 0M7.5 1.827a5.673 5.673 0 0 0-4.193 9.494A4.971 4.971 0 0 1 7.5 9.025a4.97 4.97 0 0 1 4.193 2.296A5.673 5.673 0 0 0 7.5 1.827m3.482 10.152A4.023 4.023 0 0 0 7.5 9.975a4.023 4.023 0 0 0-3.482 2.004A5.648 5.648 0 0 0 7.5 13.173c1.312 0 2.52-.446 3.482-1.194M5.15 6.505a2.35 2.35 0 1 1 4.7 0a2.35 2.35 0 0 1-4.7 0m2.35-1.4a1.4 1.4 0 1 0 0 2.8a1.4 1.4 0 0 0 0-2.8"
            clipRule="evenodd"
          />
        </svg>
      );
    case 'home':
      return <Home stroke={stroke} fill={stroke} />;
    case 'logout':
      return <Logout stroke={stroke} fill={stroke} />;
    case 'project-settings':
      return <ProjectSettings stroke={stroke} fill={stroke} />;
    case 'navigate-back':
      return <NavigateBackIcon />;
    case 'navigate-next':
      return <NavigateNextIcon />;
    case 'zoom-in':
      return <ZoomInIcon />;
    case 'zoom-out':
      return <ZoomOutIcon />;
    case 'check-mark':
      return <CheckMarkIcon stroke={stroke} fill={stroke} width={size} height={size} />;
    case 'filter-icon':
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9 10.9688V11.5V13.2812L11 14.9062V11.5V10.9688L11.3438 10.5312L16.4375 4.5H3.53125L8.625 10.5312L9 10.9688ZM2 4.5V3H3.5H16.5H18V4.5V5L12.5 11.5V16.0938V18L11 16.8125L7.5 14V11.5L2 5V4.5Z"
            fill={stroke || 'var(--primary-200, #177BA6)'}
          />
        </svg>
      );
    case 'cross':
      return (
        <svg
          width="25"
          height="25"
          onClick={onClick}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="cursor-pointer"
          {...rest}>
          <path d="M14.7812 6.28125L11.0312 10L14.75 13.7188L15.2812 14.25L14.25 15.3125L13.7188 14.7812L10 11.0625L6.28125 14.7812L5.75 15.3125L4.6875 14.25L5.21875 13.7188L8.9375 10L5.21875 6.28125L4.6875 5.75L5.75 4.6875L6.28125 5.21875L10 8.96875L13.7188 5.25L14.25 4.71875L15.3125 5.75L14.7812 6.28125Z" />
        </svg>
      );
    case 'arrow-up':
      return (
        <svg
          onClick={onClick}
          width="10"
          height="7"
          viewBox="0 0 10 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path d="M0 6L5 0L10 6H0Z" fill="white" />
        </svg>
      );

    case 'arrow-down':
      return (
        <svg
          onClick={onClick}
          width="10"
          height="7"
          viewBox="0 0 10 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path d="M0 0H10L5 6L0 0Z" fill="white" />
        </svg>
      );
    case 'arrow-left':
      return (
        <svg
          onClick={onClick}
          className={className}
          data-testid="arrow-left"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9.5 11H11H15.5V9H11H9.5V7.5V5.625L5.09375 10L9.5 14.4062V12.5V11ZM11 14.5V16H9.5H9L4.03125 11.0625L3 10L4.03125 8.96875L9 4H9.5H11V5.5V6V7.5H12.5H15.5H17V9V11V12.5H15.5H12.5H11V14V14.5Z"
            fill="#0A3A4C"
          />
        </svg>
      );
    case 'arrow-right':
      return (
        <svg
          onClick={onClick}
          className={className}
          data-testid="arrow-right"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M10.5 9H9H4.5V11H9H10.5V12.5V14.4062L14.875 10L10.5 5.625V7.5V9ZM9 5.5V4H10.5H11L15.9375 8.96875L17 10L15.9375 11.0625L11 16H10.5H9V14.5V14V12.5H7.5H4.5H3V11V9V7.5H4.5H7.5H9V6V5.5Z"
            fill="#0A3A4C"
          />
        </svg>
      );
    case 'chevron-down':
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.29289 7.29289C5.68342 6.90237 6.31658 6.90237 6.7071 7.29289L9.99999 10.5858L13.2929 7.29289C13.6834 6.90237 14.3166 6.90237 14.7071 7.29289C15.0976 7.68342 15.0976 8.31658 14.7071 8.70711L10.7071 12.7071C10.3166 13.0976 9.68341 13.0976 9.29289 12.7071L5.29289 8.70711C4.90237 8.31658 4.90237 7.68342 5.29289 7.29289Z"
            fill="#177BA6"
          />
        </svg>
      );
    case 'button-dots':
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M8.75 3.75H11.25V6.25H8.75V3.75ZM8.75 8.75H11.25V11.25H8.75V8.75ZM11.25 13.75V16.25H8.75V13.75H11.25Z"
            fill="#177BA6"
          />
        </svg>
      );
    case 'close':
      return (
        <svg
          width="20"
          height="20"
          onClick={onClick}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...rest}>
          <path
            d="M14.7812 6.28125L11.0312 10L14.75 13.7188L15.2812 14.25L14.25 15.3125L13.7188 14.7812L10 11.0625L6.28125 14.7812L5.75 15.3125L4.6875 14.25L5.21875 13.7188L8.9375 10L5.21875 6.28125L4.6875 5.75L5.75 4.6875L6.28125 5.21875L10 8.96875L13.7188 5.25L14.25 4.71875L15.3125 5.75L14.7812 6.28125Z"
            fill="var(--primary-50,#2AACE2)"
          />
        </svg>
      );
    case 'warning':
      return (
        <svg
          width={size}
          height={size}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M2.84375 15.5L9.125 4.53125L10 3L10.8438 4.53125L17.125 15.5L18 17H16.25H3.71875H2L2.84375 15.5ZM15.4062 15.5L10 6.03125L4.5625 15.5H15.4062ZM9.25 11.25V8.5H10.75V11.25V12H9.25V11.25ZM10.75 14.5H9.25V13H10.75V14.5Z"
            fill="#EF4444"
          />
        </svg>
      );
    case 'arrow-back':
      return <BackArrowIcon />;
    case 'archive':
      return <ArchiveIcon onClick={onClick} className={className} {...rest} />;
    default:
      console.error(`Unknown icon type: ${iconType}`);
      return null;
  }
};

export default SvgIcon;
